class Model {
	constructor (payload = {}) {
		// Call parent constructor if this class extends another (e.g., BasePicturesModel)
		if (this.constructor.fields) {
			this.constructor.mapFields(payload, this.constructor.fields(), this)
		}
		if (this.constructor.hasMany) {
			this.constructor.mapMany(payload, this.constructor.hasMany(), this)
		}
	}

	static mapFields (payload, fields, instance) {
		for (const fieldKey in fields) {
			const fieldDefinition = fields[fieldKey]
			const incomingValue = payload[fieldKey]

			// Check if field definition is a class constructor
			if (typeof fieldDefinition === 'function') {
				// Instantiate class if incoming value exists and isn't already an instance
				if (incomingValue !== null && !(incomingValue instanceof fieldDefinition)) {
					instance[fieldKey] = new fieldDefinition(incomingValue)
				} else if (incomingValue !== null) {
					// Already an instance, use as-is
					instance[fieldKey] = incomingValue
				} else {
					// No incoming value, set to null
					instance[fieldKey] = null
				}
			} else if (Array.isArray(fieldDefinition)) {
				// Handle array fields (e.g., tasks: [], pictures: [])
				instance[fieldKey] = Array.isArray(incomingValue) ? incomingValue : fieldDefinition
			} else if (typeof fieldDefinition === 'object' && fieldDefinition !== null) {
				// Handle plain object fields (e.g., manufacturer: { id: null, name: null })
				instance[fieldKey] = incomingValue !== undefined ? incomingValue : fieldDefinition
			} else {
				// Handle primitives (strings, numbers, booleans, null)
				instance[fieldKey] = incomingValue !== undefined ? incomingValue : fieldDefinition
			}
		}
	}

	static mapMany (payload, hasManyFields, instance) {
		for (const fieldKey in hasManyFields) {
			const RelationClass = hasManyFields[fieldKey]

			if (payload[fieldKey] && Array.isArray(payload[fieldKey])) {
				// Map incoming array to class instances
				instance[fieldKey] = payload[fieldKey].map(item => {
					return item instanceof RelationClass ? item : new RelationClass(item)
				})
			} else {
				// Initialize empty array if no data provided
				instance[fieldKey] = []
			}
		}
	}
}

export default Model
